interface ContainProps {
  className?: string;
  children?: any;
  style?: any;
}

const defaultProps: ContainProps = {};

const Contain = ({ children, className, style }: ContainProps) => {
  const css = ["covr-contain"];

  if (className) {
    css.push(className);
  }

  return (
    <div className={css.join(" ")} style={style}>
      {children}
    </div>
  );
};

Contain.defaultProps = defaultProps;

export default Contain;
